import Transform from "@ember-data/serializer/transform";
import BioExamPrescription from "parog-web/models/bio-exam/bio-exam-prescription";

interface Serialized {
  id: string;
  prescriptible: boolean;
  selected: boolean;
}

export default class BioExamPrescriptionsTransform extends Transform {
  override deserialize(serialized: Serialized[]): BioExamPrescription[] {
    return serialized.map(
      item =>
        new BioExamPrescription(
          item["id"],
          item["prescriptible"],
          item["selected"]
        )
    );
  }

  override serialize(deserialized: BioExamPrescription[]): Serialized[] {
    const result = deserialized.map(item => {
      return {
        id: item.id,
        prescriptible: item.prescriptible,
        selected: item.selected
      };
    });

    return result;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "bio-exam-prescriptions": BioExamPrescriptionsTransform;
  }
}
